import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["modal"];
  static values = { url: String };

  connect() {
    this.modal = this.modalTarget;
    document.body.appendChild(this.modal);
  }

  disconnect() {
    window.bootstrap.Modal.getInstance(this.modal)?.dispose();
    this.modal.remove();
  }

  open() {
    window.bootstrap.Modal.getOrCreateInstance(this.modal).show();
    this.rendered = this.rendered || this.render();
  }

  async render() {
    const pages = this.modal.querySelector("[data-window-sticker-pages]");
    try {
      await Promise.all([
        import("pdfjs-dist/legacy/build/pdf"),
        import("pdfjs-dist/legacy/build/pdf.worker"),
      ]);
      const pdf = await window.pdfjsLib.getDocument(this.urlValue).promise;
      for (let number = 1; number <= pdf.numPages; number++) {
        pages.appendChild(await this.renderPage(await pdf.getPage(number), pages.clientWidth));
      }
    } catch (error) {
      console.error(error);
      this.rendered = null;
      this.modal.querySelector("[data-window-sticker-error]").hidden = false;
    } finally {
      this.modal.querySelector("[data-window-sticker-loading]").hidden = true;
    }
  }

  async renderPage(page, width) {
    const scale = (width / page.getViewport({ scale: 1 }).width) * Math.max(window.devicePixelRatio, 2);
    const viewport = page.getViewport({ scale });
    const canvas = document.createElement("canvas");
    canvas.width = viewport.width;
    canvas.height = viewport.height;
    await page.render({ canvasContext: canvas.getContext("2d"), viewport }).promise;
    return canvas;
  }
}
